import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
export default function withSafeAreaProvider(Component) {
    const WithSafeAreaProvider = props => (React.createElement(SafeAreaProvider, null,
        React.createElement(Component, { ...props })));
    return WithSafeAreaProvider;
}
